import { LABELS, formatPrice, calculateDiscount } from '../../lib'

interface ProductPriceProps {
  price: number
  specialPrice?: number | null
  msrp?: number | null
  priceSuffix?: string
}

const PRICE_WRAPPER_CLASSES = 'h-[40px] xl:h-[50px] flex flex-col justify-end items-start'
const REGULAR_PRICE_CLASSES = 'text-lg xl:text-xl font-medium line-through font-sec-font'
const PRICE_BASE_CLASSES = 'text-2xl font-bold font-sec-font'
const DISCOUNT_PRICE_CLASSES = `${PRICE_BASE_CLASSES} text-custom-red`
const DEFAULT_PRICE_CLASSES = `${PRICE_BASE_CLASSES} text-text-color`
const MSRP_CLASSES = 'flex flex-row items-start text-lg xl:text-xl font-medium font-sec-font'

export function ProductPrice({
  price,
  specialPrice,
  msrp,
  priceSuffix = 'cu TVA',
}: ProductPriceProps) {
  if (price === 0) return null

  const discount = calculateDiscount(price, specialPrice)
  const hasDiscount = discount > 0
  const finalPrice = (hasDiscount && specialPrice !== null && specialPrice !== undefined)
    ? specialPrice
    : price

  return (
    <div className={PRICE_WRAPPER_CLASSES}>
      {hasDiscount ? (
        <DiscountedPrice
          regularPrice={price}
          finalPrice={finalPrice}
          priceSuffix={priceSuffix}
        />
      ) : (
        <RegularPrice
          price={price}
          msrp={msrp}
          priceSuffix={priceSuffix}
        />
      )}
    </div>
  )
}

interface DiscountedPriceProps {
  regularPrice: number
  finalPrice: number
  priceSuffix?: string
}

function DiscountedPrice({
  regularPrice,
  finalPrice,
  priceSuffix,
}: DiscountedPriceProps) {
  return (
    <div className="flex flex-col items-start">
      <p className={REGULAR_PRICE_CLASSES}>
        {formatPrice(regularPrice)}
      </p>
      <p className={DISCOUNT_PRICE_CLASSES}>
        {formatPrice(finalPrice)}
        {priceSuffix && ` ${priceSuffix}`}
      </p>
    </div>
  )
}

interface RegularPriceProps {
  price: number
  msrp?: number | null
  priceSuffix?: string
}

function RegularPrice({
  price,
  msrp,
  priceSuffix,
}: RegularPriceProps) {
  const hasMsrp = !!msrp && msrp > 0
  const priceClasses = hasMsrp ? DISCOUNT_PRICE_CLASSES : DEFAULT_PRICE_CLASSES

  return (
    <div className="flex flex-col items-start xl:gap-1">
      {hasMsrp && (
        <div className={MSRP_CLASSES}>
          <span>{LABELS.MSRP_PREFIX}</span>
          <span> {formatPrice(msrp)}</span>
        </div>
      )}
      <p className={priceClasses}>
        {formatPrice(price)}
        {priceSuffix && ` ${priceSuffix}`}
      </p>
    </div>
  )
}
